import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu } from 'primereact/menu'

const LANGS = ['tr', 'en'] as const
type Lang = (typeof LANGS)[number]

/**
 * Dil seçici — Figma: segmented TR|EN yerine **dropdown butonu** ("TR ⌄"). Buton mevcut dili + chevron
 * gösterir; tıklanınca TR/EN menüsü açılır, seçilince tüm arayüz o dile geçer (aktif dil menüde vurgulu).
 */
export default function LanguageSwitch() {
  const { t, i18n } = useTranslation()
  const active: Lang = i18n.language.startsWith('tr') ? 'tr' : 'en'
  const menuRef = useRef<Menu>(null)

  const items = LANGS.map((lang) => ({
    label: lang.toUpperCase(),
    className: lang === active ? 'lang-item-on' : undefined,
    command: () => {
      if (lang !== active) i18n.changeLanguage(lang)
    },
  }))

  return (
    <>
      <Menu model={items} popup ref={menuRef} popupAlignment="right" className="lang-menu" />
      <button
        type="button"
        className="lang-btn"
        aria-label={t('shell.language')}
        aria-haspopup="menu"
        onClick={(e) => menuRef.current?.toggle(e)}
      >
        <span>{active.toUpperCase()}</span>
        <i className="pi pi-chevron-down" aria-hidden="true" />
      </button>
    </>
  )
}
